import MetropolitanPlanningTrafficEngineering from "../../asset/Directorates/inner/Metropolitan Planning & Traffic Engineering.png";
import LandDevelopment from "../../asset/Directorates/inner/Land Development.png";
import Engineering from "../../asset/Directorates/inner/Engineering.png";
import Finance from "../../asset/Directorates/inner/Finance.png";
import Administration from "../../asset/Directorates/inner/Administration.png";
import LandBuildingControl from "../../asset/Directorates/inner/Land Use & Building Control.png";
import EstateManagement from "../../asset/Directorates/inner/Estate Management.png";
import Architecture from "../../asset/Directorates/inner/Architecture.png";
import ITWing from "../../asset/Directorates/inner/IT Wing.png";
import PRWing from "../../asset/Directorates/inner/PR Wing.png";

export const directoratesData = {
  "Administration Directorate": {
    name: "Administration Directorate",
    overview:
      "The Administration Department of the Rawalpindi Development Authority RDA manages internal affairs and administrative operations to ensure smooth functioning of the Authority. It supports all departments through effective human resource management and institutional governance.",
    functionsResponsibilities: [
      "Human resource management including appointments, postings, transfers, and promotions ",
      "Establishment and service matters",
      "Office administration and record management ",
      "Enforcement of rules, regulations, and discipline",
      "Coordination with provincial government departments",
    ],
    commitment:
      "The department is committed to transparency, efficiency, and compliance with government regulations.",
    image: Administration,
  },
  "Finance Directorate": {
    name: "Finance Directorate",

    overview:
      "The Finance Department is responsible for financial planning, budgeting, expenditure control, and revenue management of RDA, ensuring proper utilization of public funds.",
    functionsResponsibilities: [
      "Preparation and management of annual budgets ",
      "Financial planning and forecasting",
      "Processing of payments and financial approvals",
      "Maintenance of accounts and financial records",
      "Compliance with audit and financial rules ",
    ],
    commitment:
      "The department ensures financial discipline, transparency, and accountability in all financial matters.",
    image: Finance,
  },
  "Engineering Directorate": {
    name: "Engineering Directorate",

    overview:
      "The Engineering Department of RDA is responsible for planning, execution, and supervision of infrastructure development projects to support urban growth.",
    functionsResponsibilities: [
      "Construction and maintenance of roads and infrastructure",
      "Water supply, sewerage, and drainage systems",
      "Supervision of development works",
      "Quality control and compliance with engineering standards",
      "Coordination with contractors and consultants",
    ],
    commitment:
      "The department is dedicated to delivering safe, durable, and high-quality infrastructure.",
    image: Engineering,
  },
  "Land Development Directorate": {
    name: "Land Development Directorate",

    overview:
      "The Land Development Department plans and executes development schemes in accordance with approved master plans and development policies.",
    functionsResponsibilities: [
      "Planning and execution of development schemes",
      "Infrastructure provision in new developments",
      "Implementation of approved layout plans ",
      "Coordination with planning and engineering departments",
    ],
    commitment:
      "The department promotes planned, sustainable, and organized urban expansion.",
    image: LandDevelopment,
  },
  "Estate Management Directorate": {
    name: "Estate Management Directorate",

    overview:
      "The Estate Management Department manages RDA-owned properties and land, ensuring transparent allotment and proper record keeping.",
    functionsResponsibilities: [
      "Allotment, transfer, and mutation of properties ",
      "Maintenance of land and estate records ",
      "Recovery of dues and lease charges",
      "Possession and demarcation matters",
    ],
    commitment:
      "The department ensures transparency, accuracy, and protection of public assets.",
    image: EstateManagement,
  },
  "Metropolitan Planning & Traffic Engineering Directorate": {
    name: "Metropolitan Planning & Traffic Engineering Directorate",

    overview:
      "The Metropolitan Planning & Traffic Engineering Department is responsible for strategic urban planning and traffic management to ensure sustainable growth and efficient mobility across the metropolitan area.",
    functionsResponsibilities: [
      "Preparation and implementation of master plans",
      "Land use zoning and urban policy formulation",
      "Traffic planning and traffic impact assessments ",
      "Road safety planning and congestion management",
      "Coordination with traffic police and planning agencies",
    ],
    commitment:
      "The department works to create a well-planned city with safe and efficient transportation systems.",
    image: MetropolitanPlanningTrafficEngineering,
  },
  "Land Use & Building Control Directorate": {
    name: "Land Use & Building Control Directorate",

    overview:
      "The Land Use & Building Control Department regulates land use and construction activities to ensure compliance with approved plans, zoning regulations, and building bylaws.",
    functionsResponsibilities: [
      "Approval of building plans and layouts",
      "Enforcement of zoning and land use regulations",
      "Monitoring construction activities",
      "Action against illegal constructions",
      "Issuance of completion and occupancy certificates",
    ],
    commitment:
      "The department ensures lawful development, safety, and planned urban growth.",
    image: LandBuildingControl,
  },
  "Architecture Directorate": {
    name: "Architecture Directorate",

    overview:
      "The Architecture Department of RDA provides architectural guidance and design review to ensure functional, aesthetic, and sustainable development.",
    functionsResponsibilities: [
      "Architectural design review of development projects",
      "Guidance on urban design and aesthetics",
      "Compliance with architectural standards and bylaws",
      "Support to planning and building control departments",
    ],
    commitment:
      "The department promotes quality architecture and a visually harmonious urban environment.",
    image: Architecture,
  },
  "IT Wing": {
    name: "IT Wing",

    overview:
      "The IT Wing manages RDA’s digital infrastructure and technological initiatives to improve efficiency, transparency, and citizen services.",
    functionsResponsibilities: [
      "Development and maintenance of IT systems and portals",
      "Management of digital records and databases",
      "Cybersecurity and system support",
      "Implementation of e-governance initiatives",
      "Technical support for departments and public platforms",
    ],
    commitment:
      "The IT Wing is committed to digital transformation and reliable technology services.",
    image: ITWing,
  },
  "PR Wing": {
    name: "PR Wing",

    overview:
      "The Public Relations PR Wing manages communication between RDA and the public, ensuring accurate information dissemination and positive public engagement.",
    functionsResponsibilities: [
      "Public information and media coordination",
      "Press releases and official announcements",
      "Handling public queries and awareness campaigns",
      "Image building and stakeholder communication",
    ],
    commitment:
      "The PR Wing ensures transparent communication and strengthens public trust in RDA.",
    image: PRWing,
  },
};

export const directoratesPage = [
  { route: "/administration", name: "Administration Directorate" },
  { route: "/finance", name: "Finance Directorate" },
  { route: "/engineering", name: "Engineering Directorate" },
  {
    route: "/land-development-estate-management",
    name: "Land Development Directorate",
  },
  { route: "/estate-management", name: "Estate Management Directorate" },
  {
    route: "/metropolitan-planning-traffic-engineering",
    name: "Metropolitan Planning & Traffic Engineering Directorate",
  },
  {
    route: "/land-building-control",
    name: "Land Use & Building Control Directorate",
  },
  { route: "/architecture", name: "Architecture Directorate" },
  { route: "/IT-wing", name: "IT Wing" },
  { route: "/PR-wing", name: "PR Wing" },
];
